
















import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

import ExtranetSettingV1 from './components/settingv1.vue';

@Component({
  components: {
    ExtranetSettingV1
  },
})
export default class ExtranetSetting extends Vue {
  selectTabKey = 'v1'
  tabListNoTitle = [
    {
      key: 'v1',
      tab: '远程连接设置',
    },
  ];

  private mounted() {
    console.log('初始化设置页面');
  }

  onTabChange(key) {
    this.selectTabKey = key;
  }

}
